const GENERIC_EVENT_NAME = 'analytics_event';

export { GENERIC_EVENT_NAME };
